export interface NormalModeConfig {
  hopDuration: number;
  revealRadius: number;
}

export interface RevealModeConfig {
  hopDuration: number;
  revealRadius: number;
}

export interface WarpModeConfig {
  warmupHops: number;
  warpHops: number;
  cooldownHops: number;
  warpHopDuration: number;
  normalHopDuration: number;
  revealRadius: number;
  minSafeDistance: number;
}

export interface PathfindingConfig {
  strategy: 'bfs' | 'corridor';
  corridorWidth: number;
  deviationPenalty: number;
  maxNodes: number;
  timeoutMs: number;
}

export interface TravelConfig {
  normal: NormalModeConfig;
  reveal: RevealModeConfig;
  warp: WarpModeConfig;
  flightHeight: number;
  pathfinding: PathfindingConfig;
  routeHalfWidth: number;
  routeHalfWidthWarp: number;
  routeColors: {
    normal: [number, number, number];
    reveal: [number, number, number];
    warp: [number, number, number];
  };
}

export function defaultTravelConfig(): TravelConfig {
  return {
    normal: { hopDuration: 10, revealRadius: 0 },
    reveal: { hopDuration: 15, revealRadius: 4 },
    warp: {
      warmupHops: 3,
      warpHops: 20,
      cooldownHops: 3,
      warpHopDuration: 2,
      normalHopDuration: 10,
      revealRadius: 0,
      minSafeDistance: 2,
    },
    flightHeight: 0.9,
    routeHalfWidth: 0.12,
    routeHalfWidthWarp: 0.20,
    pathfinding: {
      strategy: 'corridor',
      corridorWidth: 8,
      deviationPenalty: 0.25,
      maxNodes: 1_000_000,
      timeoutMs: 60_000,
    },
    routeColors: {
      normal: [0.3, 0.6, 1.0],
      reveal: [0.2, 1.0, 0.4],
      warp: [0.7, 0.3, 1.0],
    },
  };
}
